import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { PlateletCountAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-platelet-count-slot',
    templateUrl: './platelet-count-slot.component.html',
    styleUrl: './platelet-count-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlateletCountSlotComponent implements SheetSlotComponentBase {

	action!: PlateletCountAction;
	value!: string | null;

	@Input('action') set updateAction(action: PlateletCountAction | null) {
		this.action = action as PlateletCountAction;
		this.value = this.action.averageMultiplied?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}